<template>
  <v-list>
    <v-list-group v-for="module in visibleModules" :key="module.id" :prepend-icon="module.icon" :append-icon="getSubModules(module.id).length > 1 ? 'mdi-chevron-down' : ''">
      <template v-slot:activator>
        <!-- MULTIPLE sub-modules -->
        <v-list-item-content v-if="getSubModules(module.id).length > 1">
          <span>
            {{ module.name }}
          </span>
        </v-list-item-content>

        <!-- SINGLE sub-module -->
        <v-list-item-content v-else>
          <router-link class="text-decoration-none" :to="`/${getSubModules(module.id)[0]?.route}`" :class="getSubModules(module.id)[0]?.is_new == 1 ? 'new-menu-item' : ''">
            {{ getSubModules(module.id)[0]?.name }}
          </router-link>
        </v-list-item-content>
      </template>

      <!-- SUB-MODULE LIST -->
      <v-list-item v-for="sub in getSubModules(module.id)" v-if="getSubModules(module.id).length > 1" :key="sub.id" link>
        <v-list-item-content>
          <router-link class="text-decoration-none" :to="`/${sub.route}`"
            :class="sub?.is_new == 1 ? 'new-menu-item' : ''">
            {{ sub.name }}
          </router-link>
        </v-list-item-content>
      </v-list-item>

    </v-list-group>
  </v-list>


</template>


<script>
import { mapActions, mapState } from "vuex";
import { ADMINS__ACTIONS } from "@/store/action-types";


export default {
  data: () => ({}),

  computed: {
    ...mapState("admins", ["loggedAdmin"]),

    isFullAdmin() {
      return this.loggedAdmin?.permissions == "full_access";
    },

    visibleModules() {
      if (this.isFullAdmin) {
        return this.loggedAdmin?.modules.sort(
          (a, b) => a.sort_order - b.sort_order
        );
      }

      return this.loggedAdmin?.modules.filter((mod) => {
        return this.loggedAdmin?.subModules.some((sub) =>
          sub.module_id === mod.id &&
          this.loggedAdmin?.permissions[sub.id] > 0
        );
      }).sort((a, b) => a.sort_order - b.sort_order);
    },

  },

  methods: {
    ...mapActions("admins", [ADMINS__ACTIONS.GETADMIN]),

    getSubModules(moduleId) {
      if (this.isFullAdmin) {
        return this.loggedAdmin?.subModules
          .filter((sub) => sub.module_id === moduleId)
          .sort((a, b) => a.sort_order - b.sort_order);
      }

      return this.loggedAdmin?.subModules
        .filter(
          (sub) =>
            sub.module_id === moduleId &&
            this.loggedAdmin?.permissions[sub.id] > 0
        )
        .sort((a, b) => a.sort_order - b.sort_order);
    },
  },

  async created() {
    await this[ADMINS__ACTIONS.GETADMIN]();
  },

};
</script>

<style>
.v-navigation-drawer .v-list:not(.v-select-list) {
  height: 100vh;
}
</style>